import React from "react";
import { ChevronDown } from "lucide-react";

const COVER =
  "/media/header.jpg";
const LOGO =
  "/media/logo-sc.png";

export default function HeroCover() {
  const scrollNext = () => {
    const el = document.getElementById("home");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="relative w-full h-screen overflow-hidden bg-black">
      {/* Background photo — vintage skiers */}
      <img
        src={COVER}
        alt="Vintage skiers — L'agence des gens"
        className="kenburns absolute inset-0 w-full h-full object-cover"
      />

      {/* Colour wipe reveal on entrance */}
      <div className="colour-wipe absolute inset-0 pointer-events-none bg-gradient-to-r from-transparent via-[#FF5B24]/70 to-transparent mix-blend-overlay" />

      {/* Vignette for navbar legibility */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/80 pointer-events-none" />

      {/* SC logo overlay — positioned independently, sized responsively */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <img
          src={LOGO}
          alt="SC — L'agence des gens"
          className="w-[68%] sm:w-[55%] md:w-[46%] lg:w-[38%] xl:w-[32%] max-w-[520px] h-auto drop-shadow-2xl select-none"
        />
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollNext}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/80 hover:text-white transition-colors group"
        aria-label="Découvrir"
      >
        <span className="font-mono text-[10px] uppercase tracking-widest">
          Découvrir
        </span>
        <span className="w-9 h-9 rounded-full border border-white/40 flex items-center justify-center group-hover:bg-[#FF5B24] group-hover:border-[#FF5B24] transition-all animate-bounce">
          <ChevronDown className="w-4 h-4" />
        </span>
      </button>
    </section>
  );
}

